/**
 * API ve validasyon hatalarını kullanıcıya Türkçe göstermek için.
 */

const ENGLISH_TO_TURKISH: Record<string, string> = {
  'Invalid input: expected number, received NaN': 'Geçerli bir sayı girin.',
  'Expected number, received NaN': 'Geçerli bir sayı girin.',
  'Expected number, received string': 'Bu alan sayı olmalıdır.',
  'Invalid input': 'Geçersiz giriş.',
  'Required': 'Bu alan zorunludur.',
  'Internal Server Error': 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
  'Network Error': 'Bağlantı hatası. İnternet bağlantınızı kontrol edin.',
  'timeout of': 'İstek zaman aşımına uğradı.',
  'Request failed with status code 400': 'Geçersiz istek (400).',
  'Request failed with status code 401': 'Oturum açmanız gerekiyor.',
  'Request failed with status code 403': 'Bu işlem için yetkiniz yok.',
  'Request failed with status code 404': 'İstenen kayıt bulunamadı.',
  'Request failed with status code 409': 'Kayıt başka bir işlemle çakışıyor. Sayfayı yenileyip tekrar deneyin.',
  'Request failed with status code 500': 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
  'Insufficient stock': 'Yetersiz stok.',
  'Validation failed': 'Girilen bilgiler geçersiz.',
  'Product name is required': 'Ürün adı gerekli.',
  'Quantity must be 0 or greater': 'Miktar 0 veya daha büyük olmalı.',
  'Unit price must be 0 or greater': 'Alış fiyatı 0 veya daha büyük olmalı.',
  'Retail price must be 0 or greater': 'Satış fiyatı 0 veya daha büyük olmalı.',
  'Unit price cannot be greater than retail price': 'Alış fiyatı satış fiyatından yüksek olamaz.',
  'Invalid login credentials': 'E-posta veya şifre hatalı.',
  'Email not confirmed': 'E-posta adresinizi doğrulayın.',
};

/**
 * Hata nesnesinden kullanıcıya gösterilecek Türkçe mesajı döndürür.
 * - Axios: error.response?.data?.message veya error.message
 * - Zod/validation: error.message
 */
export function getErrorMessage(
  error: unknown,
  fallback: string = 'İşlem sırasında hata oluştu'
): string {
  if (error == null) return fallback;

  let raw = '';
  if (typeof error === 'string') {
    raw = error;
  } else if (error && typeof error === 'object') {
    const e = error as Record<string, unknown>;
    const response = e.response as Record<string, unknown> | undefined;
    if (response?.data && typeof response.data === 'object') {
      const data = response.data as Record<string, unknown>;
      if (typeof data.message === 'string' && data.message.trim()) {
        raw = data.message;
      }
    }
    if (!raw && typeof e.message === 'string') raw = e.message;
  }

  const trimmed = raw?.trim();
  if (!trimmed) return fallback;

  // Bilinen İngilizce mesajları Türkçe'ye çevir
  const translated = ENGLISH_TO_TURKISH[trimmed];
  if (translated) return translated;

  // "Request failed with status code XXX" benzeri axios mesajları
  if (trimmed.startsWith('Request failed with status code')) {
    const code = trimmed.replace(/\D/g, '');
    if (code === '400') return 'Geçersiz istek. Girilen bilgileri kontrol edin.';
    if (code === '401') return 'Oturum açmanız gerekiyor.';
    if (code === '403') return 'Bu işlem için yetkiniz yok.';
    if (code === '404') return 'İstenen kayıt bulunamadı.';
    if (code === '409') return 'Kayıt başka bir işlemle çakışıyor. Sayfayı yenileyip tekrar deneyin.';
    if (code === '500') return 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.';
  }
  if (trimmed.includes('timeout')) return 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.';
  if (trimmed.toLowerCase().includes('network')) return 'Bağlantı hatası. İnternet bağlantınızı kontrol edin.';

  // Backend zaten Türkçe mesaj dönüyorsa olduğu gibi kullan
  return trimmed;
}
